import React, { useEffect, useRef, useState } from "react";
import { Select } from "antd";
import "./InquirySelect.scss";

export default function InquirySelect({ id, name, value, onChange, options }) {
  const fieldRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const field = fieldRef.current;
    const modalBody = field?.closest(".modal-scroll-area") || field?.closest(".ant-modal-body");
    if (!open || !modalBody) return undefined;

    // The popup sits outside the scrolling body, so hide it when its field leaves view.
    const closeWhenFieldIsHidden = () => {
      const fieldBounds = field.getBoundingClientRect();
      const bodyBounds = modalBody.getBoundingClientRect();
      if (fieldBounds.top < bodyBounds.top || fieldBounds.bottom > bodyBounds.bottom) {
        setOpen(false);
      }
    };

    modalBody.addEventListener("scroll", closeWhenFieldIsHidden, { passive: true });
    return () => modalBody.removeEventListener("scroll", closeWhenFieldIsHidden);
  }, [open]);

  return (
    <div className="inquiry-select" ref={fieldRef}>
      <input type="hidden" name={name} value={value} />
      <Select
        id={id}
        value={value}
        onChange={onChange}
        open={open}
        onDropdownVisibleChange={setOpen}
        options={options.map((option) => ({ value: option, label: option }))}
        getPopupContainer={(trigger) =>
          trigger.closest(".ant-modal-content") || trigger.parentElement
        }
        popupClassName="inquiry-select-popup"
        placement="bottomLeft"
        virtual={false}
        listHeight={216}
        showSearch={false}
      />
    </div>
  );
}
